<template>
  <div class="d-flex justify-center align-center">
    <div style="text-align: center;">
      <v-progress-circular indeterminate :color="color"></v-progress-circular>
      <p class="mt-3">{{ text }}</p>
    </div>
  </div>
</template>

<script>
const name = 'loading'

const props = {
  loading: {
    type: Boolean,
    required: true
  },
  text: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false,
    default: 'primary'
  }
}

export default {
  name,
  props
}
</script>
